import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import rightArrow from '../../../assets/image/rightArrow.svg';
import { connect } from "react-redux";

function Breadcrumb(props) {

  const { title } = props;
  const [breadcrums, setBreadcrumbs] = useState(null);

  useEffect(() => {
    setBreadcrumbs(title.breadCrumb);
  }), [title.breadCrumb];

  const history = useHistory();

  const pushToDirect = () => {
    const val = pageTitleThree.split(" ")[1];
    if (val == undefined) {
      // console.log('pageTitleThree', val);
    } else {
      const filter = val.substring(1, pageTitleThree.split(" ")[1].length - 1).trim();
      history.push(filter);
    }
  }

  function routToHome(){
    history.push('/analyst-home');
  }

  // console.log('breadcrumb from props', title);
  // console.log('breadcrumb from state', breadcrums);


  return (
    <>
      {breadcrums !== null ?
        <>
          <p className="breadcrumb-text" onClick={routToHome} > {breadcrums.breadOne}</p>

          {breadcrums.breadTwo !== null ?
            <>
              <div className="breadcrumb-icon">
                <img src={rightArrow} alt="rightArrow" />
              </div>

              <p className="breadcrumb-text" >{breadcrums.breadTwo} </p>
            </>
            : null}

          {breadcrums.breadThree !== null ?
            <>
              <div className="breadcrumb-icon">
                <img src={rightArrow} alt="rightArrow" />
              </div>

              <p className="breadcrumb-text" >{breadcrums.breadThree} </p>
            </>
            : null}

        </>
        : null}
    </>
  );
}

const mapStateToProps = (state) => ({
  title: state.title
});

export default connect(mapStateToProps)(Breadcrumb);
